<template>
  <section class="has-background-grey-lighter has-text-centered section">
    <img style="height: 200px" src="../assets/partner.svg" alt="Partner" />
    <p class="title has-text-centered">Our Partners</p>
    <p class="subtitle">
      We only work with the best to ensure optimal results for you
    </p>
    <div class="container">
      <div :key="row" v-for="row in Array(numRows).keys()" class="columns">
        <div
          class="column"
          v-for="col in Array(numItemsPerRow).keys()"
          :key="col"
        >
          <a
            v-if="partners[numItemsPerRow * row + col]"
            :href="partners[numItemsPerRow * row + col].url"
          >
            <img
              class="partner"
              :src="getImageUrl(partners[numItemsPerRow * row + col].image)"
              alt="image"
            />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Partners",
  components: {},
  computed: {
    numRows() {
      return Math.ceil(this.partners.length / this.numItemsPerRow);
    },
  },
  data: function () {
    return {
      numItemsPerRow: 4,
      partners: [
        {
          url: "https://tyk.io/",
          image: "tyk-logo.svg",
        },
        {
          url: "http://www.sundray.com/",
          image: "sundraylogo-small.png",
        },
        {
          url: "http://www.sangfor.com/",
          image: "sangforlogo-small.png",
        },
        {
          url: "http://www.zerto.com/",
          image: "zertologo-small.png",
        },
        {
          url: "https://www.spectralogic.com/",
          image: "spectralogo-small.png",
        },

        {
          url: "https://www.ambedded.com.tw/en/index/index.html",
          image: "ambeddedlogo.png",
        },

        {
          url: "http://www.overlandstorage.com/",
          image: "overlandtandberg-logo.svg",
        },

        {
          url: "https://www.aishu.cn/en",
          image: "eisoologo.png",
        },

        {
          url: "https://www.symantec.com/",
          image: "symanteclogo-small.png",
        },

        {
          url: "https://www.veritas.com/",
          image: "veritaslogo-small.png",
        },
        {
          url: "https://www.suse.com/",
          image: "suselogo-small.png",
        },

        {
          url: "https://www.atto.com/",
          image: "attologo-small.png",
        },

        {
          url: "https://www.microfocus.com/",
          image: "microfocus-small.png",
        },

        {
          url: "http://www.infortrend.com/",
          image: "infortrendlogo-small.png",
        },
      ],
    };
  },
  created() {},
  methods: {
    getImageUrl(filename) {
      return require(`../assets/${filename}`);
    },
  },
};
</script>

<style scoped>
.partner {
  margin-top: 3rem;
  max-height: 50px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
